import { useQuery } from '@apollo/client';
import { AppContext } from '@edx/frontend-platform/react';
import { useContext } from 'react';

import { GET_PROGRAM_BY_ID, IS_ENROLLED_IN_PROGRAM } from '../queries/programById';


export const useProgramDetail = (programId) => {
  const { data, loading, error } = useQuery(GET_PROGRAM_BY_ID, {
    variables: { id: programId },
    skip: !programId,
  });

  return {
    program: data?.programs?.[0] || null,
    loading,
    error,
  };
};

export const useIsEnrolledInProgram = (programId) => {
  const { authenticatedUser } = useContext(AppContext);
  const userId = authenticatedUser?.id ?? authenticatedUser?.userId;

  const { data, loading } = useQuery(IS_ENROLLED_IN_PROGRAM, {
    variables: { userId, programId },
    skip: !userId || !programId,
  });

  return {
    isEnrolled: (data?.programEnrollments?.length || 0) > 0,
    loading,
  };
};
